import styled from 'styled-components';
import { breakpoints, css } from 'src/styles/theme';
import { FeatureDemandBannerStyled } from '../FeatureDemandBannerStyled';
import { rem } from 'polished';

export const FeatureDemandBannerOV = styled(FeatureDemandBannerStyled)`
    
`;
